export default __webpack_public_path__ + "static/sectorlab-3690d8f928517ed2cb0cb3f93a9d26de.png";